import React, { useContext, useEffect, useState } from "react";
import {
  ManageTransactionLayout,
  SearchDropdownWithAPI,
  SearchableList,
  FieldDropSide,
  WithDrawalApprovalCard,
  DraftCard,
  LoaderWrapper,
  FormControlSearch,
  TabFilter,
} from "../../../components";
import { Formik, Field } from "formik";
import InfiniteScroll from "react-infinite-scroller";
import { getDraftLoanEmployee } from "../../../services";

import {
  Button,
  Form,
  Row,
  Col,
  Toast,
  InputGroup,
  Image,
} from "react-bootstrap";
import {
  FLOW_TYPES,
  formFields,
  getAdvancedPathWithParam,
  getPathWithParam,
  manageTransactionFormNames,
  MANAGE_TRANSACTION_ROUTES,
  RECORDS_TO_FETCH,
  LOAN_STATUS,
} from "../../../utils";
// import { ROUTES, MANAGE_TRANSACTION_ROUTES, ApplicationRoute } from "../utils";
import {
  manageTransactionStore,
  setManageTransactionToastInfo,
} from "../../../contexts";
import { useDeepEffect, useRequest } from "../../../abstracts";
import authService from "../../../components/api-authorization/AuthorizeService";
import TransactionFilterCard from "../TransactionFilterCard";
import LoanApprovalCard from "../../../components/LoanApprovalCard/LoanApprovalCard";
import { getApprovalLoanEmployee } from "./../../../services/transaction/index";

const PendingLoan = (props) => {
  const { state, dispatch } = useContext(manageTransactionStore);
  // const history = useHistory();
  const { history } = props;
  const [roleName, setRoleName] = useState("");
  const formName = manageTransactionFormNames.MANAGE_LOAN;
  const fields = formFields[formName];
  const [apiRequest, setApiRequest] = useState({
    companyId: null,
    planId: null,
    requestedDateFrom: null,
    requestedDateTo: null,
    employeeNameOrSSNSearch: "",
    isAscendingByRequestedDate: true,
    from: 0,
    offset: RECORDS_TO_FETCH,
  });
  const { response, loading } = useRequest({
    method: getDraftLoanEmployee,
    defaultResponse: [],
  });
  const [append, setAppend] = useState(false);
  const [totalEmployees, setTotalEmployees] = useState(0);
  const [stopInfiniteScroll, setStopInfiniteScroll] = useState(false);
  const [loanListEmployee, setLoanListEmployee] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [dataLoad, setDataLoad] = useState(false);
  const [pendingLoanDetails, setPendingLoanDetails] = useState([]);
  const [count, setCount] = useState();

  const onBackClick = () => {
    history.push(
      getPathWithParam({
        path: MANAGE_TRANSACTION_ROUTES.APPROVAL,
      })
    );
    // dispatch(
    //   setManageTransactionToastInfo({
    //     showToast: true,
    //     toastMessage: "Withdrawal request is rejected",
    //     toastMessage1: "Employee Name|Reason ",
    //     reject: true,
    //   })
    // );
  };
  const buttons = [
    {
      label: "Back",
      variant: "secondary",
      type: "button",
      flow: [FLOW_TYPES.ADD, FLOW_TYPES.EDIT, FLOW_TYPES.SAVE],
      onClick: onBackClick,
    },
  ];

  // useEffect(() => {
  //   getRole().then((res) => setRoleName(res));
  // }, []);
  // const getRole = async () => {
  //   return await authService.getRole();
  // };

  useDeepEffect(() => {
    if (!append) {
      setDataLoad(true);
    }
    setIsLoading(true);
    getApprovalLoanEmployee(apiRequest)
      .then((response) => {
        setDataLoad(false);
        setTotalEmployees(response.count);
        if (
          response?.loanInProgressDetailsAwaitingForApproval?.length <
          RECORDS_TO_FETCH
        )
          setStopInfiniteScroll(true);
        if (append) {
          setLoanListEmployee([
            ...loanListEmployee,
            ...response?.loanInProgressDetailsAwaitingForApproval,
          ]);
          setPendingLoanDetails(
            [
              ...loanListEmployee,
              ...response?.loanInProgressDetailsAwaitingForApproval,
            ].map((_) => _)
          );
        } else {
          setLoanListEmployee(
            response?.loanInProgressDetailsAwaitingForApproval
          );
          setPendingLoanDetails(
            response?.loanInProgressDetailsAwaitingForApproval.map((_) => _)
          );
        }
        setIsLoading(false);
        // dispatch(
        //   setManagePageLevelData({
        //     formName: formName,
        //     fieldData: request,
        //   })
        // );
      })
      .catch((error) => {
        // Handle Errors
        setIsLoading(false);
      });
  }, [apiRequest]);

  useEffect(() => {
    let loanCount = { count: 0, newLoan: 0, refinance: 0, reamortize: 0 };
    pendingLoanDetails.map((_) => {
      if (LOAN_STATUS[_.loanStatus] == "AwaitingApproval")
        loanCount = {
          ...loanCount,
          count: loanCount.count + 1,
          newLoan: loanCount.newLoan + 1,
        };
      else if (
        LOAN_STATUS[_.loanStatus] == "RefinancingRequestAwaitingApproval"
      )
        loanCount = {
          ...loanCount,
          count: loanCount.count + 1,
          refinance: loanCount.refinance + 1,
        };
      else
        loanCount = {
          ...loanCount,
          count: loanCount.count + 1,
          reamortize: loanCount.reamortize + 1,
        };
    });
    setCount(loanCount);
  }, [pendingLoanDetails]);

  const onTabSwitch = (val) => {
    switch (val) {
      case "All":
        setLoanListEmployee(pendingLoanDetails);
        break;
      case "New Loan Requests":
        setLoanListEmployee(
          pendingLoanDetails.filter(
            (_) => LOAN_STATUS[_.loanStatus] == "AwaitingApproval"
          )
        );
        break;
      case "Loan Re-Amortzie":
        setLoanListEmployee(
          pendingLoanDetails.filter(
            (_) =>
              LOAN_STATUS[_.loanStatus] ==
              "ReAmortizationRequestAwaitingApproval"
          )
        );
        break;
      case "Loan Refinance":
        setLoanListEmployee(
          pendingLoanDetails.filter(
            (_) =>
              LOAN_STATUS[_.loanStatus] == "RefinancingRequestAwaitingApproval"
          )
        );
        break;
    }
  };

  const onSearch = (val) => {};

  const tabData = [
    {
      count: count?.count ?? 0,
      label: "All",
      active: true,
    },
    {
      count: count?.newLoan ?? 0,
      label: "New Loan Requests",
      active: false,
    },
    {
      count: count?.reamortize ?? 0,
      label: "Loan Re-Amortzie",
      active: false,
    },
    {
      count: count?.refinance ?? 0,
      label: "Loan Refinance",
      active: false,
    },
  ];

  return (
    <ManageTransactionLayout
      layoutHeader="Loan Request Pending Approval"
      buttons={buttons}
      pageFlow={FLOW_TYPES.ADD}
    >
      <TransactionFilterCard
        fields={fields}
        append={append}
        setAppend={setAppend}
        apiRequest={apiRequest}
        setApiRequest={setApiRequest}
        setLoanListEmployee={setLoanListEmployee}
      />
      {/* <div className="d-flex-row w-65 loan-approval-search flex-nowarp mb-3">
        <InputGroup>
          <InputGroup.Prepend>
            <InputGroup.Text className="plan-search-button">
              <Image src="/assets/icons/svg/search.svg" width="14px" />
            </InputGroup.Text>
          </InputGroup.Prepend>
          <FormControlSearch
            type="search"
            placeholder="Search by  employee ID, plan name , request type "
            onChange={(val) => onSearch(val)}
          />
        </InputGroup>
      </div> */}

      <TabFilter count={count} onTabSwitch={onTabSwitch} tabData={tabData} />

      {/* <div className="d-flex flex-row justify-content-end text-right records-text ft-14 mr-3">
        {totalEmployees} Requests
      </div> */}

      <div style={{ height: "59%", overflow: "scroll" }}>
        <LoaderWrapper isLoading={dataLoad}>
          <InfiniteScroll
            pageStart={0}
            loadMore={() => {
              setAppend(true);
              setApiRequest((apiRequest) => {
                return {
                  ...apiRequest,
                  from: loanListEmployee?.length,
                };
              });
            }}
            hasMore={!stopInfiniteScroll}
            initialLoad={false}
            threshold={100}
            useWindow={false}
            loader={
              loanListEmployee.length != 0 && (
                <div className="loader" key={0}>
                  Loading ...
                </div>
              )
            }
          >
            {loanListEmployee?.map((ti) => {
              return (
                <LoanApprovalCard
                  employeeRolloverin={ti}
                  title={ti}
                  onClickOfCard={() => {
                    history.push(
                      getAdvancedPathWithParam({
                        path: `${MANAGE_TRANSACTION_ROUTES.PENDINGLOANAPPROVAL}`,
                        pathParam: [FLOW_TYPES.EDIT, ti.employeeId, ti.id, 1],
                      })
                    );
                  }}
                />
              );
            })}
          </InfiniteScroll>
        </LoaderWrapper>
      </div>
    </ManageTransactionLayout>
  );
};

export default PendingLoan;
